export default __webpack_public_path__ + "static/media/test_video.cb319c13.mp4";